/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const List16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M3 11a1 1 0 011 1v1a1 1 0 01-1 1H2a1 1 0 01-1-1v-1a1 1 0 011-1zm0 1H2v1h1v-1zm11.444 0c.307 0 .556.224.556.5 0 .245-.197.449-.456.492l-.1.008H5.556C5.249 13 5 12.776 5 12.5c0-.245.197-.45.456-.492l.1-.008h8.888zM3 6a1 1 0 011 1v1a1 1 0 01-1 1H2a1 1 0 01-1-1V7a1 1 0 011-1zm0 1H2v1h1V7zm11.444 0c.307 0 .556.224.556.5 0 .245-.197.449-.456.492l-.1.008H5.556C5.249 8 5 7.776 5 7.5c0-.245.197-.45.456-.492l.1-.008h8.888zM3 1a1 1 0 011 1v1a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h1zm0 1H2v1h1V2zm11.444 0c.307 0 .556.224.556.5 0 .245-.197.449-.456.492l-.1.008H5.556C5.249 3 5 2.776 5 2.5c0-.245.197-.45.456-.492l.1-.008h8.888z"
        />
    </AccessibleSVG>
);

export default List16;
